import { LogoutOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { Space, Spin, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import HeaderDropdown from './HeaderDropdown';

export const AvatarName = () => {
  const { session } = useAppContext();
  return <Typography.Text>{session.user?.name}</Typography.Text>;
};
export const AvatarDropdown = ({ menu, children }) => {
  const navigate = useNavigate();
  const { resolveOrganizationPath } = useOrganizationPath();
  const { session } = useAppContext();
  const onMenuClick = (event) => {
    const { key } = event;
    if (key === 'logout') {
      session.logout().then(() => {
        navigate('/', { replace: true });
      });
      return;
    }
    navigate(resolveOrganizationPath(`/account/${key}`));
  };
  const loading = (
    <Space size="small">
      <Spin size="small" />
    </Space>
  );
  if (!session.user?.name) {
    return loading;
  }
  const menuItems = [
    ...(menu
      ? [
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人信息',
          },
          {
            key: 'organizations',
            icon: <TeamOutlined />,
            label: '组织管理',
          },
          {
            type: 'divider',
          },
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];
  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
      trigger={['click']}
    >
      {children}
    </HeaderDropdown>
  );
};
